import PricesBusinessSection from "../views/PricesBusinessSection/PricesBusinessSection";
import ProfitStation from "../views/ProfitStation/ProfitStation";

import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

export const monetizationRoutes = [
  {
    collapse: true,
    name: "Margenes",
    icon: MonetizationOnIcon,
    state: "profitsSection",
    inSidebar: true,
    isProtected: true,
    rule: "PROFIT_BUSINESS",
    views: [
      {
        path: "/razon_social",
        name: "Margen por Empresa",
        mini: "ME",
        component: PricesBusinessSection,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "PROFIT_BUSINESS",
      },
      {
        path: "/margen_plantas",
        name: "Margen por Planta",
        mini: "MP",
        component: ProfitStation,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "PROFIT_BUSINESS",
      },
    ],
  },
]